<template>
    <div>
        <v-list dense>
            <v-list-item v-for="(result, r) in RESULTS" :key="r" @click="selectLayer(r)">
                {{getLayerTitle(result.features[0].id)}}
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'LayerList',
  computed: {
    ...mapState('featureInfo', {
      RESULTS: 'results',
    }),
  },

  data() {
    return {};
  },

  methods: {
    getLayerTitle(id) {
      console.log(`GET: ${id}`);
      return this.$store.getters.GET_LAYERS[id.split('.')[0]].title;
    },
    selectLayer(idx) {
      this.$store.dispatch('featureInfo/SELECT_QUERY_LAYER', idx);
    },
  },
};
</script>

<style scoped>

</style>
